import { createStore } from 'vuex'
import { RootState } from './types'
import auth from './modules/auth'
import dashboard from './modules/dashboard'
import properties from './modules/properties'
import units from './modules/units'
import tenants from './modules/tenants'
import invoices from './modules/invoices'
import payments from './modules/payments'
import expenses from './modules/expenses'
import maintenance from './modules/maintenance'
import users from './modules/users'
import history from './modules/history'
import adminAccounts from './modules/adminAccounts'

export default createStore<RootState>({
  modules: {
    auth,
    dashboard,
    properties,
    units,
    tenants,
    invoices,
    payments,
    expenses,
    maintenance,
    users,
    history,
    adminAccounts
  }
})
